import { config } from "@/config/config";
import Image from "next/image";
import Link from "next/link";

export default function InstitucionalHome() {
  return (
    <>
      <div className="rbt-banner-area rbt-banner-8 variation-02">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-10 offset-lg-1">
              <div className="content">
                <div className="inner text-center">
                  <h1 className="title">
                    A Aulé nasceu com a missão de tornar a educação <b className="theme-gradient is-visible">acessível a todos.</b>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="rbt-about-area about-style-1 bg-color-white pb-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <div className="content">
                <Image
                  src="/novos/img/teo-do-aule-grande.png"
                  width="0"
                  height="0"
                  sizes="100vw"
                  className="w-100 h-100 radius-10"
                  alt="Aulé - O reforço que seu filho precisa para aprender"
                  loading="eager"
                />
              </div>
            </div>
            <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="700">
              <div className="inner pl--50 pl_sm--5">
                <div className="content text-start">
                  <span className="rbt-badge-6 bg-primary">Quem somos</span>
                  <p className="description fs-2 mt--30">
                    Sabemos que muitos pais enfrentam desafios na hora de ajudar os filhos nos estudos. Por isso, nossa plataforma foi criada para facilitar esse processo,
                    oferecendo conteúdos de qualidade, suporte e ferramentas práticas para um aprendizado eficiente.
                  </p>
                  <p className="description">
                    <strong>Nosso compromisso é transformar a educação, um estudante de cada vez.</strong>
                  </p>
                  <div className="read-more-btn mt--40">
                    <Link className="rbt-btn rbt-marquee-btn radius-round btn-gradient" href={config.dash_shop}>
                      <span data-text="Assine agora">Assine agora</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="rbt-call-to-action-area rbt-section-gap bg-gradient-8 mt-5">
        <div className="container">
          <div className="row g-5 align-items-center content-wrapper">
            <div className="col-xxl-3 col-xl-3 col-lg-6">
              <div className="inner">
                <div className="content text-start">
                  <h2 className="title color-white mb-2">Assine agora</h2>
                  <h6 className="title fs-2 color-white">Planos a partir de R$ 19,99!</h6>
                </div>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6">
              <div className="inner-content text-start">
                <p className="color-white">
                  Pronto para transformar a educação do seu filho? Comece hoje mesmo a ajudar seu filho a alcançar melhores resultados nos estudos, com aulas dinâmicas e suporte
                  que fazem a diferença. Assine a Aulé e veja os resultados!
                </p>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6">
              <div className="call-to-btn text-start text-xl-end">
                <Link className="rbt-btn btn-white hover-icon-reverse" href={config.dash_shop}>
                  <span className="icon-reverse-wrapper">
                    <span className="btn-text">Assine agora</span>
                    <span className="btn-icon">
                      <i className="feather-arrow-right"></i>
                    </span>
                    <span className="btn-icon">
                      <i className="feather-arrow-right"></i>
                    </span>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

